import { render, staticRenderFns } from "./assistente.vue?vue&type=template&id=0d3536a5&"
import script from "./assistente.vue?vue&type=script&lang=js&"
export * from "./assistente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports